import Header from 'components/headers/bulletins'
import { useState } from 'react'
import DotsLoading from 'components/loadings/dotsLoading'
import { toggleSupportModal } from 'store/redux/sidebar'
import { useDispatch, useSelector } from 'react-redux'
import SupportModal from 'components/modals/supportModal'
import { RootState } from 'store/redux'
import useGetPromissory from 'modules/promissory/hooks/useGetPromissory'
import { formatDueDate } from '../promissoryDetails/customTabs/utility'
import UseSendCodeForPromissory from 'modules/promissory/hooks/UseSendCode'
import PromissoryModal from './modals'
import Num2persian from 'utilities/helper/num2Persian'

export default function PromissoryNoteDetails() {
    const dispatch = useDispatch()
    const { isOpenSupportModal } = useSelector(
        (state: RootState) => state.sideBarControler
    )

    const { data, isLoading } = useGetPromissory()
    const [isChecked, setIsChecked] = useState(false)

    const filteredPromissories =
        data?.filter((localPromissory) =>
            ['pub', 'sgn', 'unsgn'].includes(localPromissory.state)
        ) || []

    const firstPromissory =
        filteredPromissories && filteredPromissories.length > 0
            ? filteredPromissories[0]
            : null

    const handleCheckboxToggle = () => {
        setIsChecked((prev) => !prev)
    }
    const [showModal, setShowModal] = useState(false)
    const { isLoading: sendCodeLoading, mutate: sendCodeMutate } =
        UseSendCodeForPromissory()

    const handleOpenModal = async () => {
        setShowModal(true)
        try {
            await Promise.all(
                filteredPromissories.map(async (promissoryArray) => {
                    try {
                        if (promissoryArray.issuer_phone_number) {
                            sendCodeMutate({
                                phone_number:
                                    '0' +
                                    promissoryArray.issuer_phone_number.slice(
                                        3
                                    ),
                            })
                            setShowModal(true)
                        } else {
                            console.error('Phone number is missing')
                        }
                    } catch (error) {
                        console.error(
                            `Inquiry failed for track_id: ${promissoryArray.track_id_publish}`,
                            error
                        )
                    }
                })
            )
        } catch (error) {
            console.error('Error handling state:', error)
        }
    }

    const handleClose = () => setShowModal(false)

    return (
        <>
            <div className="flex flex-col bg-[#F2F2F2] h-screen">
                <div className=" grow-0">
                    <Header title={`مشخصات سفته`} />
                </div>
                <div className=" grow bg-white px-2 py-2 w-full">
                    <div className=" mt-20 mx-2">
                        <div className=" mt-3 rounded-lg border-1 border-[#C9CFD6] p-3">
                            {isLoading ? (
                                <DotsLoading />
                            ) : (
                                <>
                                    <div className="text-center">
                                        <p className="mb-2">مبلغ سفته:</p>
                                        <p className="mb-2">
                                            <span className="font-bold">
                                                {firstPromissory?.amount.toLocaleString()}
                                            </span>{' '}
                                            ریال{' '}
                                        </p>
                                        <p className="mb-2">
                                            {firstPromissory ? (
                                                Num2persian(
                                                    (
                                                        firstPromissory.amount /
                                                        10
                                                    ).toString()
                                                )
                                            ) : (
                                                <p>
                                                    No promissory note available
                                                </p>
                                            )}{' '}
                                            تومان
                                        </p>
                                        <div className="flex justify-between text-sm my-3">
                                            <p>تاریخ سر رسید</p>
                                            <p>
                                                {formatDueDate(
                                                    firstPromissory?.due_date
                                                )}
                                            </p>
                                        </div>
                                        <div className=" flex justify-between text-sm">
                                            <p>در وجه</p>
                                            <p className="">
                                                {firstPromissory?.receiver_name}
                                            </p>
                                        </div>
                                    </div>
                                    <div>
                                        <h2 className="text-green-1 font-bold mt-5">
                                            اطلاعات صادر کننده
                                        </h2>
                                        <div className=" flex justify-between text-sm  my-3">
                                            <p>نام ونام خانوادگی</p>
                                            <p className="">
                                                {firstPromissory?.issuer_name}
                                            </p>
                                        </div>
                                        <div className=" flex justify-between text-sm">
                                            <p>شماره موبایل</p>
                                            <p className="">
                                                {'0' +
                                                    firstPromissory?.issuer_phone_number.slice(
                                                        3
                                                    )}
                                            </p>
                                        </div>
                                    </div>
                                </>
                            )}
                        </div>

                        <div
                            className="flex items-center mt-4 cursor-pointer"
                            onClick={handleCheckboxToggle}
                        >
                            <div
                                className={`w-6 h-6 border-2 rounded-xl ${
                                    isChecked
                                        ? 'bg-green-1 border-green-1'
                                        : 'bg-white border-gray-2'
                                } flex justify-center items-center`}
                            >
                                {isChecked && (
                                    <svg
                                        className="w-4 h-4 text-white"
                                        fill="none"
                                        stroke="currentColor"
                                        viewBox="0 0 24 24"
                                        xmlns="http://www.w3.org/2000/svg"
                                    >
                                        <path
                                            strokeLinecap="round"
                                            strokeLinejoin="round"
                                            strokeWidth="2"
                                            d="M5 13l4 4L19 7"
                                        ></path>
                                    </svg>
                                )}
                            </div>
                            <label
                                className="ml-3 text-gray-2 select-none cursor-pointer mr-2"
                                onClick={handleCheckboxToggle}
                            >
                                صحت اطلاعات فوق را تایید می کنم
                            </label>
                        </div>
                    </div>
                </div>
                <div className="grow-0 mx-2 mt-2">
                    <div className=" my-1 text-center">
                        <p>نیاز به راهنمایی دارید؟</p>
                        <p
                            className=" text-[#808080] underline-offset-8"
                            onClick={() =>
                                dispatch(
                                    toggleSupportModal({
                                        isOpenSupportModal: true,
                                    })
                                )
                            }
                        >
                            با مشاور همیان تماس بگیرید
                        </p>
                    </div>
                    <button
                        className={`w-full rounded-lg text-white py-3 mt-4 mb-2 ${
                            isChecked
                                ? 'bg-green-1'
                                : 'bg-gray-3 cursor-not-allowed'
                        }`}
                        disabled={!isChecked}
                        onClick={handleOpenModal}
                    >
                        تایید
                    </button>
                    <PromissoryModal
                        show={showModal}
                        onClose={handleClose}
                        phone={
                            '0' + firstPromissory?.issuer_phone_number.slice(3)
                            // '09109464475'
                        }
                    />
                </div>
            </div>
            <SupportModal
                show={isOpenSupportModal}
                onHide={() =>
                    dispatch(toggleSupportModal({ isOpenSupportModal: false }))
                }
            />
        </>
    )
}
